import { render, staticRenderFns } from "./GlossaryPhases.vue?vue&type=template&id=ae1d4fda&scoped=true&"
import script from "./GlossaryPhases.vue?vue&type=script&lang=js&"
export * from "./GlossaryPhases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1d4fda",
  null
  
)

export default component.exports